import React from 'react';
import ReactDOM from "react-dom";
import { ILookup } from "@talxis/base-controls";
import { Lookup as LookupComponent } from "@talxis/base-controls";

interface IInputs {
    value: ComponentFramework.PropertyTypes.LookupProperty;
    IsInlineNewEnabled?: ComponentFramework.PropertyTypes.StringProperty;
    MultipleEnabled?: ComponentFramework.PropertyTypes.StringProperty;
    EnableNavigation: ComponentFramework.PropertyTypes.StringProperty;
    ForceDisable?: ComponentFramework.PropertyTypes.StringProperty;
}
interface IOutputs {
    value?: ComponentFramework.LookupValue[];
}

export class Lookup implements ComponentFramework.StandardControl<IInputs, IOutputs> {
    private _notifyOutputChanged: () => void;
    private _container: HTMLDivElement;
    private _outputs: IOutputs = {};

    constructor() { }

    public init(context: ComponentFramework.Context<IInputs>, notifyOutputChanged: () => void, state: ComponentFramework.Dictionary, container: HTMLDivElement) {
        this._notifyOutputChanged = notifyOutputChanged;
        this._container = container;
    }
    public updateView(context: ComponentFramework.Context<IInputs>): void {
        ReactDOM.render(React.createElement(LookupComponent, {
            context: context,
            parameters: {
                value: context.parameters.value,
                EnableNavigation: {
                    raw: context.parameters.EnableNavigation?.raw === 'false' ? false : true
                },
                IsInlineNewEnabled: {
                    raw: context.parameters.IsInlineNewEnabled?.raw === 'true'
                },
                MultipleEnabled: {
                    raw: context.parameters.MultipleEnabled?.raw === 'true'
                },
                ForceDisable: {
                    raw: context.parameters.ForceDisable?.raw === 'true'
                }

            },
            onNotifyOutputChanged: (outputs: any) => {
                this._outputs = outputs;
                this._notifyOutputChanged();
            }
        } as any), this._container);
    }

    public getOutputs(): IOutputs {
        return this._outputs;
    }

    public destroy(): void {
        ReactDOM.unmountComponentAtNode(this._container);
    }
}